import type { VenueHudProps } from "../types";
import { AimControl, PowerMeter, SportsButtons, TennisAimLine, TennisHelp, WalkPause, useSportsControls } from "./controls";
import { sportsHudView } from "./hudModel";
import { OutcomeBanner } from "./OutcomeBanner";
import "./sports.css";

/**
 * The sports center's controls while the panel is collapsed ("Hide"): the score line, the zone's big buttons (Swing /
 * Shoot / Kick / Play ...), the power meter and the aims, with the same keys. A game in progress never loses its
 * controls. Away from the courts it shows nothing (the collapsed header stays). The outcome banner shows either way.
 */
export function SportsCompact({ shared, mine, send, localActorId, events }: VenueHudProps) {
  const view = sportsHudView(shared, mine, localActorId);
  const controls = useSportsControls(view, send);
  const banner = <OutcomeBanner events={events} localActorId={localActorId} />;
  if (!view.buttons.length)
    return (
      <>
        <WalkPause controls={controls} />
        {banner}
      </>
    );
  return (
    <div className="sports-compact" data-testid="sports-compact" data-zone={view.zone ?? "none"}>
      <WalkPause controls={controls} />
      {banner}
      {view.lines[0] ? (
        <p className="sports-compact-line" data-testid="sports-compact-line">
          <strong>{view.title}</strong> · {view.lines[0]}
        </p>
      ) : null}
      {view.help ? <TennisHelp text={view.help} /> : null}
      <SportsButtons view={view} controls={controls} compact />
      {view.meter ? <PowerMeter kind={view.meter} /> : null}
      {view.aimButtons ? <AimControl /> : null}
      {view.mySide !== null ? <TennisAimLine side={view.mySide} /> : null}
    </div>
  );
}
